import { Navigate } from 'react-router-dom';

import { IllustrationFrame, useRedemptionState } from '@/features/code-redemption';
import { DownloadCard } from '@/features/reward';
import { ScheduleTimeline } from '@/features/streamer-schedule';

import styles from './RewardPage.module.css';

/**
 * 보상 페이지 — 3/3 완료 후 도달.
 *
 * 구성:
 *  - Hero: 완성 축하 메시지 + 작은 회전 라벨.
 *  - 큰 일러스트 프레임(완성된 컬러 상태) + 다운로드 카드.
 *  - 다시보기용 방송 타임라인 — 종료된 방송 카드들이 흐리게 표시.
 *
 * 3/3을 채우지 않은 상태로 직접 접근하면 홈으로 리다이렉트한다.
 */
export function RewardPage(): React.JSX.Element {
  const { state, isComplete } = useRedemptionState();

  if (!isComplete) {
    return <Navigate to="/" replace />;
  }

  const filled = Math.min(state.codeCount, 3);

  return (
    <main className={styles.wrap}>
      <header className={styles.header}>
        <span className={styles.eyebrow}>완성! · 2026년 5월 5일 어린이날</span>
        <h1 className={styles.title}>
          한 장의 그림을 <span className={styles.titleAccent}>함께</span>
        </h1>
        <p className={styles.lead}>
          완성된 합동 일러스트를 다운로드 받아 간직해 주세요. 링크는 7일 동안 유효합니다.
        </p>
      </header>

      <section className={styles.grid} aria-label="완성된 일러스트와 다운로드">
        <div className={styles.illustration}>
          <IllustrationFrame revealedCount={filled} className={styles.illustrationLarge} />
        </div>
        <DownloadCard />
      </section>

      <hr className={styles.divider} aria-hidden />

      <ScheduleTimeline />
    </main>
  );
}
